import { Pipe, PipeTransform } from '@angular/core';
import { PermissionsService } from '../shared_services/permisions.service';
// import { AppStateService } from '../../services/app-state.service';


@Pipe({
  name: 'builderPermissions',
  standalone: true
})
export class AppPermissionsPipe implements PipeTransform {

  userPermissions: any;
  currentApplication = "App Builder";

  constructor(private permissionsService: PermissionsService) {
    this.userPermissions = this.permissionsService.getCurrentPermissions();
    if (!this.userPermissions) {
      this.userPermissions = {};
    }
  }


  transform(input: [string, string?]): boolean {
    // this feature is still in testing so making it as true by default to hanlde any issues
    const permissions = this.userPermissions[this.currentApplication];
    if (!permissions) return false;

    const [resourceName, permission] = input;
    if (!this.doesResourceExistInApplication(resourceName)) return false;

    const resource = permissions.resources[resourceName];
    if (!resource) return false;

    if (permission) {
      return resource.actions.includes(permission);
    }
    return true;
  }

  doesResourceExistInApplication(resourceName: string): boolean {
    if (!(this.currentApplication in this.userPermissions)) {
      return false;
    }
    return this.userPermissions[this.currentApplication]["resources"][resourceName] ? true : false;
  }



}
